import { Controller } from "stimulus";

export default class extends Controller {

  connect(){
    this.setInitialState();
  }

  setObject(event) {
    var elem = $(event.target);
    var parentElem = elem.closest('.js-pricing-rules-condition-scope');

    var object = elem.val();
    var attributeSelect = parentElem.find('.js-attribute-value');

    parentElem.find('.js-value-fields').addClass('d-none');
    parentElem.find('.js-predicate-value').addClass('d-none');

    attributeSelect.val('');
    attributeSelect.removeClass('d-none');

    attributeSelect.selectpicker('destroy');

    attributeSelect.find('option').addClass('d-none');
    attributeSelect.find('option[data-model="' + object + '"]').removeClass('d-none')

    attributeSelect.selectpicker();
    attributeSelect.selectpicker('refresh');
  }

  setAttribute(event) {
    var elem = $(event.target);
    var parentElem = elem.closest('.js-pricing-rules-condition-scope');
    var select = elem.find('option:selected');
    var types = select.data('types');

    var object = select.data('model');
    var selectObject = select.data('selectModel');

    if(selectObject != undefined) {
      var object = selectObject;
    }

    var attribute = elem.val();
    var predicateSelect = parentElem.find('.js-predicate-value');

    parentElem.find('.js-value-fields').addClass('d-none');

    predicateSelect.val('');
    predicateSelect.removeClass('d-none');

    predicateSelect.selectpicker('destroy');

    predicateSelect.find('option').addClass('d-none');
    predicateSelect.find('option[data-model="' + object + '"]').removeClass('d-none');

    types.forEach(function(type) {
      predicateSelect.find('option[data-type="' + type + '"]').removeClass('d-none');
    });

    predicateSelect.selectpicker();
    predicateSelect.selectpicker('refresh');
  }

  setPredicate(event) {
    var elem = $(event.target);
    var parentElem = elem.closest('.js-pricing-rules-condition-scope').find('.js-value-fields');
    var valueType = elem.find('option:selected').data('type');
    var inputLabel = elem.find('option:selected').data('inputLabel');

    parentElem.removeClass('d-none');

    // hide and disable all inputs
    parentElem.find('input, select').addClass('d-none');
    parentElem.find('.js-filter-label-integer-value, .js-filter-wday-value, .input-group').addClass('d-none');
    parentElem.find('.js-filter-label-integer-value').removeClass('d-inline-block');

    parentElem.find('input, select').prop('disabled', true);
    parentElem.find('input:not([type="checkbox"]), select').val('');

    var selectElem = parentElem.find('.js-filter-select-value');
    selectElem.selectpicker('destroy');
    selectElem.prop('disabled', true);
    selectElem.addClass('d-none');

    // Clean for vaccine types
    valueType = valueType.replace(/^(expires-|age-|distance-|minutes-)/, '');

    if(inputLabel == undefined || inputLabel == "") {
      parentElem.find('.js-input-label').html('Days Ago')
    } else {
      parentElem.find('.js-input-label').html(inputLabel)
    }

    // determine if input should be enabled and displayed
    switch (valueType) {
      case 'string':
        parentElem.find('.js-filter-string-value').prop('disabled', false);
        parentElem.find('.js-filter-string-value').removeClass('d-none');
        break;
      case 'boolean':
        // Fields already hidden, no value display needed
        break;
      case 'date':
        parentElem.find('.js-filter-date-value').prop('disabled', false);
        parentElem.find('.js-filter-date-value').removeClass('d-none');
        break;
      case 'time':
        parentElem.find('.js-filter-time-value').prop('disabled', false);
        parentElem.find('.js-filter-time-value').removeClass('d-none');

        parentElem.find('.timepicker').timepicker("destroy");
        parentElem.find('.timepicker').timepicker({ interval: "15" });

        break;
      case 'label-integer':
        parentElem.find('.js-filter-label-integer-value').addClass('d-inline-block');
        parentElem.find('.js-filter-label-integer-value input').prop('disabled', false);
        parentElem.find('.js-filter-label-integer-value input').removeClass('d-none');
        parentElem.find('.js-filter-label-integer-value').removeClass('d-none');
        break;
      case 'number':
        parentElem.find('.js-filter-number-value').prop('disabled', false);
        parentElem.find('.js-filter-number-value').removeClass('d-none');
        break;
      case 'decimal':
        parentElem.find('.js-filter-decimal-value').prop('disabled', false);
        parentElem.find('.js-filter-decimal-value').removeClass('d-none');
        break;
      case 'wday':
        parentElem.find('.js-filter-wday-value').removeClass('d-none');
        parentElem.find('.js-filter-wday-value input').prop('disabled', false);
        parentElem.find('.js-filter-wday-value input').removeClass('d-none');
        break;
      case 'object':
        var selectElem = parentElem.find('.js-filter-select-value');
        selectElem.prop('disabled', false);
        selectElem.removeClass('d-none');

        var select = elem.closest('.js-pricing-rules-condition-scope').find('.js-attribute-value option:selected');
        var object = select.data('model');
        var selectObject = select.data('selectModel');


        if(selectObject != undefined) {
          var object = selectObject;
        }

        selectElem.selectpicker('destroy');

        selectElem.find('option').addClass('d-none');
        selectElem.find('option[data-model="' + object + '"]').removeClass('d-none');

        selectElem.selectpicker();
        break;
    }
  }

  setConditionOperator(event) {
    var elem = $(event.target);
    var elemVal = elem.val();
    var parentElem = elem.closest('.js-pricing-rules-condition-group-scope');

    var operatorSelect = parentElem.find('.js-pricing-rules-condition-operator');

    operatorSelect.selectpicker('destroy');
    operatorSelect.val(elemVal);
    operatorSelect.selectpicker();

    this.setOperatorsLogic();
  }

  setOperators(){
    var controller = this;

    $('.js-pricing-rules-condition-group-scope:visible').each(function(){
      var operatorSelect = $(this).find('.js-pricing-rules-condition-operator');

      var elemVal = operatorSelect.find(':first').val();

      operatorSelect.selectpicker('destroy');
      operatorSelect.val(elemVal);
      operatorSelect.selectpicker();
    });

    this.syncExistingGroupOperators();
    this.setOperatorsLogic();

    [25, 50, 75, 100, 150, 200, 250, 300, 350].forEach(delay => {
      setTimeout(function(){
        controller.syncExistingGroupOperators();
        controller.setOperatorsLogic();
      }, delay);
    });
  }

  syncExistingGroupOperators() {
    var groupOperators = $('.js-pricing-rules-condition-group-scope:visible .js-pricing-rules-condition-group-operator');

    var existingVal = '';
    groupOperators.each(function(){
      if($(this).val()) {
        existingVal = $(this).val();
        return false;
      }
    });

    if(existingVal === '') { return; }

    groupOperators.each(function(){
      $(this).selectpicker('destroy');
      $(this).val(existingVal);
      $(this).selectpicker();
    });
  }

  syncGroupOperators(event) {
    var selectedOperatorVal = $(event.target).val();

    $('.js-pricing-rules-condition-group-operator').val(selectedOperatorVal).trigger("change");
  }

  setOperatorsLogic() {
    var scope = $(this.element);

    $('.js-pricing-rules-condition-group-scope:visible').each(function(){
      $(this).find('.js-pricing-rules-condition-operator').show();
      $(this).find('.js-pricing-rules-condition-operator:visible:last').hide().val('');

      if($(this).find('.js-pricing-rules-condition-scope:visible').length == 0){
        $(this).hide().val('')
      }
    });

    $('.js-delete-field').show();
    $('.js-delete-field:visible:first').hide();

    $('.js-pricing-rules-condition-group-scope:visible .js-pricing-rules-condition-group-operator').show();
    $('.js-pricing-rules-condition-group-scope:visible .js-pricing-rules-condition-group-operator:visible:last').hide().val('');

    window.loadFlatpickr();
  }

  setInitialState() {
    var controller = this;

    controller.setOperators();

    setTimeout(function(){
      $('.js-pricing-rules-condition-scope:visible').each(function(){
        var parentElem = $(this);
        var object = parentElem.find('select.js-model-object').val();
        var objectSelect = parentElem.find('.js-attribute-value');
        var objectSelectVal = objectSelect.find('option:selected').val();

        objectSelect.selectpicker('destroy');

        objectSelect.find('option').addClass('d-none');
        objectSelect.find('option[data-model="' + object + '"]').removeClass('d-none');

        var visibleOption = objectSelect.find('option[value="' + objectSelectVal + '"]:not(.d-none)').first();

        if (visibleOption.length > 0) {
          visibleOption.prop('selected', true);
          objectSelect.trigger('change'); // if you want to fire change handlers
        }

        objectSelect.selectpicker();
        objectSelect.selectpicker('refresh');

        var objectSelect = parentElem.find('select.js-attribute-value option:selected');
        var attribute = objectSelect.val();
        var types = objectSelect.data('types');

        var predicateSelect = parentElem.find('.js-predicate-value');
        var predicateSelectValue = predicateSelect.find('option:selected').val();

        predicateSelect.selectpicker('destroy');

        predicateSelect.find('option').addClass('d-none');
        predicateSelect.find('option[data-model="' + object + '"]').removeClass('d-none')

        predicateSelect.val(predicateSelectValue);

        if (Array.isArray(types)) {
          types.forEach(function(type) {
            predicateSelect.find('option[data-type="' + type + '"]').removeClass('d-none');
          });
        }

        predicateSelect.selectpicker();
        predicateSelect.selectpicker('refresh');

        var selectElem = parentElem.find('.js-filter-select-value');
        selectElem.selectpicker('destroy');
        var selectElem = parentElem.find('.js-filter-select-value');

        var initValue = selectElem.data('initvalue');
        var initObject = selectElem.data('initobject');

        selectElem.val('');

        selectElem.find('option').addClass('d-none');

        selectElem.find('option[data-model="' + initObject + '"]').removeClass('d-none');

        selectElem.find('option').prop('selected', false);

        selectElem
          .find('option[value="' + initValue + '"]:not(.d-none)')
          .prop('selected', true);

        selectElem.trigger('change');

        selectElem.selectpicker();
      });
    }, 300)


    window.loadTimepicker();
    window.loadFlatpickr();
  }
}